import {
  Box,
  Checkbox,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MoreOptionsMenu from "./MoreOptionsMenu";
import { styles } from "../../pages/Tracks/styles";
import FolderIcon from "@mui/icons-material/Folder";
import { APP_COLOR } from "../../theme";
import { FolderSectionProps } from "./types";

export const FolderSection: React.FC<FolderSectionProps> = ({
  folders,
  isLoading,
  setOpenFoldersList,
  setTracks,
  setValue,
  value,
  getAllFoldersForProject,
  selectedFolders,
  setSelectedFolders,
  isAddFolderToProject,
  onFolderClick,
  isCountUpdated,
  setIsCountUpdated,
  isBulkProjectMode,
  selectedFoldersForProjects,
  onFolderCheckboxChange,
}) => {
  const navigate = useNavigate();
  const { name, id } = useParams();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const location = useLocation();
  const { projectId, folderIdFromNavigation } = location.state || {};
  const isAddToProjectPage =
    (window.location.pathname.includes("my-tracks") &&
      folderIdFromNavigation) ||
    projectId;
  const isSharedContentPage = window.location.pathname.includes("/share/");

  const handleCheckboxChange = (folderId: string, checked: boolean) => {
    let updatedFolders: string[] = [];
    if (checked) {
      updatedFolders = [...selectedFolders, folderId];
    } else {
      updatedFolders = selectedFolders.filter((id) => id !== folderId);
    }

    setSelectedFolders(updatedFolders);
  };

  return (
    <Box>
      {folders.length > 0 && (
        <Box
          sx={{
            ...styles.foldersContainer,
            ...(isSmallScreen && styles.folderContainerMobile),
          }}
        >
          {folders.map((f, i) => {
            const folderName = f.getName();
            const folderId = f.getId();
            const isChecked = selectedFolders.includes(folderId);
            const isCheckedForProject = selectedFoldersForProjects?.has(folderId) ?? false;

            return (
              <Box key={i} sx={styles.folderMainContainer}>
                <Box
                  sx={styles.folderContainer}
                  onClick={() => {
                    if (isBulkProjectMode && onFolderCheckboxChange) {
                      onFolderCheckboxChange(folderId, !isCheckedForProject);
                      return;
                    }
                    if (!isSharedContentPage) {
                      if (setOpenFoldersList) {
                        setOpenFoldersList((prev) => [
                          ...prev,
                          { id: folderId, name: folderName },
                        ]);
                      }
                      if (value === 1) setValue(0);
                      navigate(
                        `/project/${encodeURIComponent(
                          name ?? "untitled"
                        )}/${id}/folder/${folderId}`
                      );
                      setTracks([]);
                    } else {
                      if (onFolderClick) {
                        onFolderClick(folderId);
                      }
                    }
                  }}
                >
                  {(isAddToProjectPage && isAddFolderToProject) || isBulkProjectMode ? (
                    <Checkbox
                      size="small"
                      checked={isAddFolderToProject ? isChecked : isCheckedForProject}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        if (isBulkProjectMode && onFolderCheckboxChange) {
                          onFolderCheckboxChange(folderId, e.target.checked);
                        } else {
                          handleCheckboxChange(folderId, e.target.checked);
                        }
                      }}
                      sx={{
                        padding: 0,
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                      }}
                    />
                  ) : null}
                  <FolderIcon sx={{ fontSize: "30px", color: APP_COLOR }} />
                  {folderName.length >= 9 ? (
                    <Tooltip placement="top" title={folderName} arrow>
                      <Typography sx={styles.textEllipsis}>
                        {folderName}
                      </Typography>
                    </Tooltip>
                  ) : (
                    <Typography sx={styles.textEllipsis}>
                      {folderName}
                    </Typography>
                  )}
                </Box>
                {!isSharedContentPage && (
                  <MoreOptionsMenu
                    folder={f}
                    handleRefresh={getAllFoldersForProject}
                    setTracks={setTracks}
                    setOpenFoldersList={setOpenFoldersList}
                    isCountUpdated={isCountUpdated}
                    setIsCountUpdated={setIsCountUpdated}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};
